module.exports = __webpack_public_path__ + "images/emoji/womans_clothes.72018c1358aa2e053ac2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/womans_clothes.png
// module id = 5KMN
// module chunks = 13